import { isUnprocessableImageUrl } from '@/app/utils/image';

/** ImageKit URLs: subdomain contains "assets" example: assets.isuzu-tis.com, assets-dev.isuzu-tis.com */
export const isImageKitUrl = (src: string = ''): boolean => {
  if (isUnprocessableImageUrl(src)) return false;
  try {
    const host = new URL(src).hostname.toLowerCase();
    const subdomain = host.split('.')[0] ?? '';
    return subdomain.includes('assets');
  } catch {
    return false;
  }
};
